// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ChevronLeftIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ChevronLeftIcon" ref={forwardedRef} {...props}>
      <path d="M12.364 3.636 6 10l6.364 6.364 1.057-1.057L8.121 10l5.304-5.303z" />
    </SvgIcon>
  );
});

/**
 * Indicates the ability to navigate to a previous step or view overflow items to the left. Do not use in trees to show something is closed
 * @public
 */
export const ChevronLeftIcon = /* @__PURE__ */ Object.assign(
  ChevronLeftIconComponent,
  { displayName: 'ChevronLeftIcon' },
);
